import {
  selectDestination,
  selectDestinations,
  selectDestinationLoading,
  selectDestinationsLoading,
  selectDestinationError,
} from '../core/reducers/destination.reducer';

export const getDestination = selectDestination;
export const getDestinationLoading = selectDestinationLoading;
export const getDestinations = selectDestinations;
export const getDestinationsLoading = selectDestinationsLoading;
export const getDestinationError = selectDestinationError;
